export const API_PATH = {
  PARTNER_LIST: getV1Path("partner/list"),
  ROLE_LIST: getV1Path("role/list"),
  USER_INFO: getV1Path("user"),
  LOGIN: getV1Path("user/login"),
  CHANGE_PASS: getV1Path("user/change-password"),
};

export const GENERAL = {
  GENERAL_DATA: getV1Path("report/revenue/trending"),
};

export const BALANCE_TICKET = {
  LIST: getV1Path("ticket/list"),
  DETAIL: getV1Path("ticket/detail"),
  UPDATE: getV1Path("ticket/update"),
  CREATE: getV1Path("ticket/create"),
  REFUND_TRANS: getV1Path("transaction/available/refund/list")
};

export const PARTNER_MANAGEMENT = {
  LIST: getV1Path("partner/list"),
  DETAIL: getV1Path("partner/detail"),
  UPDATE: getV1Path("partner/update"),
  CREATE: getV1Path("partner/create"),
};

export const USER_MANAGEMENT = {
  USER_LIST: getV1Path("user/list"),
  UPDATE_USER: getV1Path("user/update-user"),
  CREATE_USER: getV1Path("user/create-user"),
  RESET_PASSWORD: getV1Path("user/reset-password"),
};

export const PATH_CONFIG = {
  LIST: getV1Path("config"),
  CREATE_CONFIG: getV1Path("config/create"),
  UPDATE_CONFIG: getV1Path("config/update"),
  DELETE_CONFIG: getV1Path("config/delete"),
  CONFIG_DETAIL: getV1Path("config/detail"),
};

export const CONTENT_MANAGEMENT = {
  LIST: getV1Path("content/list-content-cms"),
  CREATE_CONTENT: getV1Path("content/create-content"),
  UPDATE_CONTENT: getV1Path("content/update-content"),
  DELETE_CONTENT: getV1Path("content/delete-content"),
};

export const COUNTRY_MANAGEMENT = {
  LIST: getV1Path("country/list-country"),
  CREATE_COUNTRY: getV1Path("country/create-country"),
  UPDATE_COUNTRY: getV1Path("country/update-country"),
  DETAIL: getV1Path("country/detail-country"),
  DELETE: getV1Path("country/delete-country"),
};

export const ROAMING_MANAGEMENT = {
  LIST: getV1Path("data/list/roaming/packages"),
  DETAIL: getV1Path("mobileData/detail"),
  CREATE: getV1Path("mobileData/create"),
  DELETE: getV1Path("mobileData/delete"),
  UPDATE: getV1Path("mobileData/update"),
  PARTNER_LIST_ROAMING: getV1Path("roaming/partner/list-roaming-partner"),
};

export const TOPUP_MANAGEMENT = {
  LIST: getV1Path("mobileData/listMobileDataPaging"),
  DETAIL: getV1Path("mobileData/detail"),
  CREATE: getV1Path("mobileData/create"),
  DELETE: getV1Path("mobileData/delete"),
  UPDATE: getV1Path("mobileData/update"),
  LIST_B2B: getV1Path("mobileData/listSyncMobileData"),
  IMPORT_FROM_B2B: getV1Path("mobileData/importArray"),
};

export const FILE_MANAGEMENT = {
  LIST: getV1Path("file/list-file"),
  UPLOAD_FILE: getV1Path("file/upload-file"),
  REPLACE_FILE: getV1Path("file/replace-file"),
  DELETE_FILE: getV1Path("/file/delete-file"),
};

export const ADDRESS_PATH = {
  PROVINCE_LIST: getV1Path("address/list-provinces"),
  PROVINCE_DETAIL: getV1Path("address/detail-provinces"),
  UPDATE_PROVINCE: getV1Path("address/update-provinces"),
  CREATE_PROVINCE: getV1Path("address/create-provinces"),
  DELETE_PROVINCE: getV1Path("address/delete-provinces"),
  DISTRICT_LIST: getV1Path("address/list-districts"),
  DISTRICT_DETAIL: getV1Path("address/detail-districts"),
  UPDATE_DISTRICT: getV1Path("address/update-districts"),
  CREATE_DISTRICT: getV1Path("address/create-districts"),
  DELETE_DISTRICT: getV1Path("address/delete-districts"),
  WARD_LIST: getV1Path("address/list-wards"),
  WARD_DETAIL: getV1Path("address/detail-wards"),
  UPDATE_WARD: getV1Path("address/update-wards"),
  CREATE_WARD: getV1Path("address/create-wards"),
  DELETE_WARD: getV1Path("address/delete-wards"),
  REGIONS: getV1Path("address/list-administrative-regions"),
  UNITS: getV1Path("address/list-administrative-units"),
};

export const PACKAGES_REGISTRAION = {
  PACKAGES_BY_PHONE: getV2Path("mobile/data/phone"),
  DEFAULT_PACKAGE: getV1Path("mobile/data/packages"),
};

export const TRAVEL_SIM = {
  LIST: getV1Path("profile/list"),
  DETAIL: getV1Path("profile/detail"),
  ADD: getV1Path("profile/ocr"),
  CREATE_PROFILE: getV2Path("profile/add"),
  CONFIRM_PROFILE_V2: getV2Path("profile/confirm"),
  CONFIRM: getV1Path("profile/confirm"),
  UPDATE: getV1Path("profile/update"),
  NATION_LIST: getV1Path("profile/location"),
  UPDATE_STATUS: getV1Path("profile/update/status"),
  CONNECT_SIM: getV1Path("profile/connect"),
  FIND_PROFILE: getV1Path("profile/find"),
  UPLOAD_MULTIPLE: getV1Path("profile/multiple/add"),
};

export const TOOLS = {
  VIDEO_GENERATION: getV1Path("tool/generate/videocall"),
};

export const SIM_TRACKING = {
  GET_LIST: getV1Path("order/sim/tracking"),
  GET_DETAIL: getV1Path("order/sim/tracking/detail"),
};

export const TRANSACTION_HISOTRY_PATHS = {
  UPDATE_STATUS: getV1Path("mobile/data/check-transaction"),
};

export const PRODUCT_MANAGEMENT = {
  LIST: getV1Path("product/list"),
  DETAIL: getV1Path("product/code/"),
  CREATE: getV1Path("product/create"),
  UPDATE: getV1Path("product/update"),
  DELETE: getV1Path("product/delete"),
  ADD_PRODUCT_USER: getV1Path("product-user/create"),
  UPDATE_PRODUCT_USER: getV1Path("product-user/update"),
  REMOVE_PRODUCT_USER: getV1Path("product-user/delete"),
};

function getV1Path(path: String) {
  return `${process.env.REACT_APP_BASE_URL}/api/v1/${path}`;
}

function getV2Path(path: String) {
  return `${process.env.REACT_APP_BASE_URL}/api/v2/${path}`;
}
